// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

// Les ressources de traduction
const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
};

// Langue du site : le français. L'anglais (locales/en) sera proposé quand toutes les pages seront traduites.
const getInitialLanguage = () => 'fr';

i18n
  .use(initReactI18next) // connecte avec react
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'fr', // si la traduction n'existe pas

    interpolation: {
      escapeValue: false, // React gère déjà l'échappement
    },
  });

document.documentElement.lang = i18n.language;

// Sauvegarder automatiquement le changement de langue
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('preferredLanguage', lng);
  } catch (error) {
    // Stockage indisponible : le choix vaut pour la session en cours
  }
  // Mettre à jour l'attribut lang de la page HTML
  document.documentElement.lang = lng;
});

export default i18n;
